import React from 'react';

import { useModal } from 'core/hooks';
import Cta, { CtaProps as ICtaProps } from 'core/components/Cta';
import CtaContainer from 'core/components/CtaContainer';
import { IProps as IModalProps } from 'core/components/Modal';
import { JssTextType } from 'core/utils/sitecore-utils';

type onClickType =
	| React.MouseEvent<HTMLButtonElement>
	| React.MouseEvent<HTMLAnchorElement>
	| React.MouseEvent<HTMLSpanElement>;

interface IModalInCtaProps {
	ctaProps: Omit<ICtaProps, 'onClick'>;
	onCtaClick?: (event?: onClickType) => void;

	modalProps: IModalProps;

	ctaDataTargetId?: string;
	modalDataTargetId?: string;
	hasCloseButton?: boolean;
	closeButtonContent?: JssTextType;
}

/**
 * @description Combined CTA and Modal components for easier importing on forms.
 * Used interfaces of CTA and Modal.
 * onCtaClick was added since we have the toggleModal method inside onClick.
 */
const ModalInCta = ({
	// CTA Props
	ctaProps,
	onCtaClick,
	// Modal Props
	modalProps,
	// Optional
	ctaDataTargetId,
	modalDataTargetId,
	hasCloseButton,
	closeButtonContent,
}: IModalInCtaProps) => {
	const [Modal, toggleModal] = useModal();

	return (
		<>
			<Modal
				data-target-id={`${modalDataTargetId}--modal-in-cta`}
				{...modalProps}
			>
				{modalProps?.children}
				{hasCloseButton && (
					<CtaContainer stackAt={null}>
						<Cta
							jssText={closeButtonContent ?? { value: 'Close' }}
							ctaStyle="primary"
							ctaType="button"
							onClick={toggleModal}
						/>
					</CtaContainer>
				)}
			</Modal>
			<Cta
				data-target-id={`${ctaDataTargetId}--modal-in--cta`}
				onClick={e => {
					toggleModal();
					onCtaClick?.(e);
				}}
				{...ctaProps}
			/>
		</>
	);
};

export default ModalInCta;
